class ProductOrderTimelineItem {
    public id: string;
    public type: 'STATUS' | 'TRACE';
    public date: number;
    public title: string;
    public subTitle?: string;
    public userName?: string;

    constructor(
        id: string,
        type: 'STATUS' | 'TRACE',
        date: number,
        title: string,
        subTitle?: string,
        userName?: string
    ) {
        this.id = id;
        this.type = type;
        this.date = date;
        this.title = title;
        this.subTitle = subTitle;
        this.userName = userName;
    }
}

export default ProductOrderTimelineItem;